import React from 'react';
import PropTypes from 'prop-types';

const CoverLetter = ({ value, onChange, title='Cover Letter' }) => [
  <strong key='title'>
    {title}
  </strong>,
  <p key='description'>
    This text will display on the front page of this report
  </p>,
  <textarea
    value={value}
    onChange={onChange}
    key='content'
    className='form-control'
    rows={9}
  />
];

CoverLetter.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  title: PropTypes.string
};


export default CoverLetter;


// WEBPACK FOOTER //
// src/components/reportLayout/CoverLetter/index.jsx